import React from 'react'
import Matter, { Runner, Engine, Render, World, Bodies, Common, Vector } from 'matter-js'
import MatterAttractors from 'matter-attractors'
import { throttle } from 'lodash'

import { Container, Reposition } from './circle.css'

let engine
let render
let attractor

export class Circle extends React.Component {
  componentDidMount() {
    const canvas = document.getElementById('circle-bounds')
    Matter.use(MatterAttractors)
    console.log(Matter)

    engine = Engine.create()
    render = Render.create({
      element: canvas,
      engine,
      options: {
        width: canvas.offsetWidth,
        height: canvas.offsetHeight,
        background: 'transparent',
        wireframeBackground: 'transparent',
        wireframes: false,
      },
    })

    // / TODO: how to disable this attractor on mobile to retain accelerometer.
    attractor = Bodies.circle(100, 100, 10, {
      isStatic: true,
      plugin: {
        attractors: [
          function (bodyA, bodyB) {
            return {
              x: (bodyA.position.x - bodyB.position.x) * 0.000001,
              y: (bodyA.position.y - bodyB.position.y) * 0.000001,
            }
          },
        ],
      },
    })

    const circle = Bodies.circle(canvas.offsetHeight / 2, canvas.offsetHeight / 2, 80, 80)

    const ground = Bodies.rectangle(
      canvas.offsetWidth / 2,
      canvas.offsetHeight,
      canvas.offsetWidth,
      1,
      {
        isStatic: true,
      }
    )

    const top = Bodies.rectangle(canvas.offsetWidth / 2, 0, canvas.offsetWidth, 1, {
      isStatic: true,
    })

    const left = Bodies.rectangle(0, canvas.offsetHeight / 2, 1, canvas.offsetHeight, {
      isStatic: true,
    })

    const right = Bodies.rectangle(
      canvas.offsetWidth,
      canvas.offsetHeight / 2,
      1,
      canvas.offsetHeight,
      {
        isStatic: true,
      }
    )

    circle.render.fillStyle = '#ffffff'
    attractor.render.fillStyle = 'transparent'
    ground.render.fillStyle = 'transparent'
    top.render.fillStyle = 'transparent'
    left.render.fillStyle = 'transparent'
    right.render.fillStyle = 'transparent'

    engine.world.gravity.scale = 0.0

    const runner = Runner.create()
    Runner.run(runner, engine)

    World.add(engine.world, [attractor, circle, ground, top, left, right])
    Engine.run(engine)
    Render.run(render)

    window.addEventListener('deviceorientation', this.updateGravityOrientation, true)
    window.addEventListener('resize', throttle(this.handleResize, 100), true)
    window.addEventListener('mousemove', throttle(this.updateGravityMouse, 100), true)
  }
  componentWillUnmount() {
    window.removeEventListener('deviceorientation', this.updateGravityOrientation, true)
    window.removeEventListener('resize', throttle(this.handleResize, 100), true)
    window.removeEventListener('mousemove', throttle(this.updateGravityMouse, 100), true)
  }

  handleResize() {
    console.log('resize')
  }

  updateGravityOrientation(event) {
    if (!engine) return

    let orientation = window.orientation,
      gravity = engine.world.gravity

    if (orientation === 0) {
      gravity.x = Common.clamp(event.gamma, -90, 90) / 90
      gravity.y = Common.clamp(event.beta, -90, 90) / 90
    } else if (orientation === 180) {
      gravity.x = Common.clamp(event.gamma, -90, 90) / 90
      gravity.y = Common.clamp(-event.beta, -90, 90) / 90
    } else if (orientation === 90) {
      gravity.x = Common.clamp(event.beta, -90, 90) / 90
      gravity.y = Common.clamp(-event.gamma, -90, 90) / 90
    } else if (orientation === -90) {
      gravity.x = Common.clamp(-event.beta, -90, 90) / 90
      gravity.y = Common.clamp(event.gamma, -90, 90) / 90
    }
  }

  updateGravityMouse(event) {
    attractor.position.x = event.clientX
    attractor.position.y = event.clientY
    const gravity = engine.world.gravity
    const x = Common.clamp(
      (event.clientX * 4) /
        (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) -
        2,
      -1,
      1
    )

    const y = Common.clamp(
      (event.clientY * 4) /
        (window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight) -
        2,
      -1,
      1
    )

    gravity.x = x
    gravity.y = y
    gravity.isPoint = true
  }

  render() {
    return (
      <Container>
        <Reposition id="circle-bounds" bounds={this.props.bounds} />
      </Container>
    )
  }
}

export default Circle
